import React from "react";
import styles from "./SixthScreen.module.css";
import FAQItem from "../components/questions/Questions";
import SocialLinks from "../components/social/Social";

const SixthScreen = () => {

    const openWhatsApp = () => {
    const phoneNumber = '972507277178'; // ללא סימנים מיוחדים
    const message = 'היי חינת הזהב, אשמח לקבל עוד פרטים לגבי האירוע שלי';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <>
      <div className={styles.headerSection}>
        <div className={styles.title}>
          שאלות <span className={styles.goldText}>נפוצות</span>
        </div>
      </div>

      <div className={styles.description}>
        
        ריכזתי כאן את התשובות לשאלות שבטוח עלו לך לראש עד היום לחצי על כל שאלה והתשובה תיפתח.
      </div>

      <FAQItem
        question="מה ההבדל בין חינה רגילה לחינה שאת מפיקה?"
        answer="חינה רגילה היא אירוע שכל אחד מארגן בנפרד עם ספקים שונים. אצלי זו חוויה שלמה – עיצוב, תלבושות, אוכל, הנחיית טקס והפעלת הקהל באירוע אחד מתואם. הכל מתוכנן לפרטים, בלי התעסקות ובלי כאב ראש. התוצאה היא ערב מרוקאי עשיר, שמח ומכובד ברמה גבוהה."
      />

      <FAQItem
        question="כמה זמן מראש כדאי לסגור?"
        answer="ברגע שסוגרים תאריך לחתונה כדאי לשריין גם את החינה. התאריכים נתפסים מהר. ככל שסוגרים מוקדם יותר, יש יותר זמן לבחור תלבושות, לעצב לפי טעם אישי ולבנות את כל הקונספט מסביב לאירוע שלך."
      />

      <FAQItem
        question="האם את מגיעה לאולם ביום האירוע?"
        answer="כן. אני מלווה כל אירוע באופן אישי. מגיעה עם הצוות, מוודאת שהכל מוכן, דואגת לסדר, מלבישה, מנחה ומרימה את הקהל. אין מצב שתישארי לבד עם ספקים או שאלות ברגע האמת."
      />

      <FAQItem
        question="מה כולל השירות שלך?"
        answer="הכול במקום אחד – תפאורה, תלבושות, עיצוב שולחנות, עוגיות מרוקאיות, מופלטות, הנחיית טקס, והפקה מלאה של הערב. יש גם תוספות מיוחדות כמו שוק פיצוחים, גמל, ויטרינות ועיצוב מבואה. כך כל החוויה נראית מושלמת ומתואמת מתחילתה ועד סופה."
      />

      <FAQItem
        question="כמה זמן לוקח כל התהליך?"
        answer="אחרי שסוגרים תאריך, קובעים יום למדידות. את והאמהות בוחרות תלבושות, סגנון וצבעים. משם אני מתאמת את כל שאר ההפקה עד ליום האירוע. את לא צריכה לדאוג לשום פרט נוסף."
      />

      <FAQItem
        question="מה מיוחד באירועים שלך?"
        answer="החינה שלי היא לא רק עיצוב. זו אווירה. אנרגיות. חיבור אמיתי לקהל. אני מנחה, שרה, צוחקת, ומשאירה את המשפחה רגועה. הניסיון שלי והחבילה השלמה יוצרים אירוע עם לב ונשמה – כזה שלא שוכחים."
      />


      <div className={styles.description}>
ובנימה אישית, חינה יש פעם אחת בחיים (אולי פעמיים 😉) אין הזדמנות שנייה לרגש הזה, לצבעים, לאנרגיה של הערב הזה.  
תני לנו לדאוג שהכול ייראה וירגיש בדיוק כמו שחלמת, ואת.. תחייכי ותהני כל הדרך לחופה
      </div>
         <button  className={styles.ctaButton} onClick={openWhatsApp}>
          לחצי כאן ואנחנו מדברות על האירוע שלך
        </button>

              <div className={styles.headerSection}>
        <div className={styles.title}>
          חפשו אותנו <span className={styles.goldText}> גם כאן </span>
        </div>
      </div>
      <SocialLinks/>
    </>
  );
};

export default SixthScreen;
